module.exports = __webpack_public_path__ + "static/img/icon_scan.24887ad0.png";